import { render, staticRenderFns } from "./tabItemTemplates.vue?vue&type=template&id=a2242926"
import script from "./tabItemTemplates.vue?vue&type=script&lang=js"
export * from "./tabItemTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports